const _ = 60, T = 224, E = 40, N = 24, A = "50%", I = -10, D = "stenn-ui-side-nav-state";
export {
  N as FLOATING_EXPAND_BUTTON_BOTTOM_MOBILE,
  A as FLOATING_EXPAND_BUTTON_TOP,
  I as INNER_EXPAND_BUTTON_RIGHT,
  _ as SIDE_NAV_COLLAPSED_WIDTH,
  T as SIDE_NAV_EXPANDED_WIDTH,
  E as SIDE_NAV_LIST_SIZE,
  D as SIDE_NAV_LOCAL_STORAGE_KEY
};
//# sourceMappingURL=constants28.mjs.map
